export function initClarity(projectId) {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);
}

export function clarityConsent() {
  window.clarity?.('consent');
}

export function clarityIdentify(userEmail) {
  if (userEmail) {
    window.clarity?.('identify', userEmail, undefined, undefined, userEmail);
    window.clarity?.('set', 'userEmail', userEmail);
  }
}

export default function (projectId, userEmail) {
  initClarity(projectId);
  clarityConsent();
  if (userEmail) {
    clarityIdentify(userEmail);
  }
}
